import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import AppBar from "@mui/material/AppBar";
import Header from "../../components/Header";
import ContactHeader from "../../components/Header/ContactHeader";
import Footer from "../../components/Footer";
import Scroll from "../Header/Scroll";
import Banner from "./components/Banner";
import Image2 from "../../assets/images/lagoon.jpg";
import ProjectDetails from "./components/ProjectDetails";

const styles = {
  paperContainer: {
    height: 300,
    backgroundImage: `linear-gradient(rgba(0,0,95,0.5),rgba(0,0,95,0.5)), url(${Image2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const Projects = () => {
  return (
    <Box>
      <Helmet>
        <title> Our Projects | Aquatic Hub Afrique</title>
      </Helmet>
      <Box
        bgcolor={"#194ec3"}
        position={"relative"}
        display={{ xs: "none", sm: "block" }}
      >
        <ContactHeader />
      </Box>
      <Scroll>
        <AppBar position={"sticky"} elevation={0} padding={"10px 0px"}>
          <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
            <Header />
          </Container>
        </AppBar>
      </Scroll>
      <Box style={styles.paperContainer}>
        <Container>
          <Banner />
        </Container>
      </Box>
      <Container>
        <ProjectDetails />
      </Container>
      <Box bgcolor={"#000058"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default Projects;
